"use strict";
exports.__esModule = true;
exports.CustomAttributeDataType = exports.CustomAttributeEntityType = void 0;
var CustomAttributeEntityType;
(function (CustomAttributeEntityType) {
    CustomAttributeEntityType[CustomAttributeEntityType["Task"] = 0] = "Task";
    CustomAttributeEntityType[CustomAttributeEntityType["Waypoint"] = 1] = "Waypoint";
    CustomAttributeEntityType[CustomAttributeEntityType["Customer"] = 2] = "Customer";
    CustomAttributeEntityType[CustomAttributeEntityType["Teams"] = 3] = "Teams";
    CustomAttributeEntityType[CustomAttributeEntityType["User"] = 4] = "User";
})(CustomAttributeEntityType = exports.CustomAttributeEntityType || (exports.CustomAttributeEntityType = {}));
var CustomAttributeDataType;
(function (CustomAttributeDataType) {
    CustomAttributeDataType[CustomAttributeDataType["Number"] = 0] = "Number";
    CustomAttributeDataType[CustomAttributeDataType["String"] = 1] = "String";
    CustomAttributeDataType[CustomAttributeDataType["Boolean"] = 2] = "Boolean";
})(CustomAttributeDataType = exports.CustomAttributeDataType || (exports.CustomAttributeDataType = {}));
//# sourceMappingURL=custom_attribute.js.map